/* eslint-disable complexity */
/* eslint-disable camelcase */
const validate = values => {
    const errors = {};
    if (!values.roleName) {
        errors.roleName = 'Please enter a role name';
    }
    if (values.roleName && !/^[A-Za-z0-9 ]{1,100}$/.test(values.roleName)) {
        errors.roleName = 'Special characters not allowed';
    }
    if (values.roleName && values.roleName.length > 50) {
        errors.roleName = 'Cannot be more than 50 characters';
    }
    if (values.roleName && values.roleName.length < 3) {
        errors.roleName = 'Must be 3 characters or more';
    }
    if (!values.roleStatus) {
        errors.roleStatus = 'Please select a status';
    }
    if (
        (!values.access_management || values.access_management.length === 0) &&
        (!values.refunds || values.refunds.length === 0) &&
        (!values.reports || values.reports.length === 0) &&
        (!values.edit_merchant_onboarding ||
            values.edit_merchant_onboarding.length === 0) &&
        (!values.merchant_onboarding ||
            values.merchant_onboarding.length === 0) &&
        (!values.manage_bin || values.manage_bin.length === 0) &&
        (!values.manage_account || values.manage_account.length === 0) &&
        (!values.dashboard || values.dashboard.length === 0) &&
        (!values.payLink || values.payLink.length === 0)
    ) {
        errors.dashboard = 'Please select at least one permission';
    }
    return errors;
};

export default validate;
